function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SwiperSlider from 'integration-web-core--socle/js/assets/modules/_swiperSlider.class';
var CarouselProduct = /*#__PURE__*/function () {
  function CarouselProduct(mainCarousel) {
    var _this = this;
    _classCallCheck(this, CarouselProduct);
    this.mainCarousel = mainCarousel;
    this.thumbnails = mainCarousel.querySelector('.m-nav-thumbnails__container');
    this.thumbnailsItems = this.thumbnails.querySelectorAll('.m-nav-thumbnails__item');
    this.thumbnailsSwiper = mainCarousel.querySelector('.m-carousel-thumbnails');
    this.mediasSwiper = mainCarousel.querySelector('.m-carousel-main');
    this.mediasArrows = this.mediasSwiper.querySelectorAll('button');
    this.medias = this.mediasSwiper.querySelector('.m-carousel-main__layout');
    this.mediasItems = this.medias.querySelectorAll('.m-carousel-main__item');
    this.currentIndex = 0;
    this.currentThumbnail = this.thumbnailsItems[0];
    this.currentMedia = this.mediasItems[0];
    lm.DOMReady(function () {
      return _this.init();
    });
  }
  return _createClass(CarouselProduct, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      // Launch swiper
      this.mediasSwiper && new SwiperSlider(this.mediasSwiper);
      this.thumbnailsSwiper && new SwiperSlider('.m-carousel-thumbnails');
      this.mediasArrows.forEach(function (arrow) {
        return arrow.addEventListener('click', function (e) {
          return _this2.onMediasArrowsClick(e, arrow);
        });
      });
      this.medias.addEventListener('scroll', function () {
        return _this2.toggleMediasArrowButtons();
      });
      this.thumbnailsItems.forEach(function (item) {
        return item.addEventListener('click', function (e) {
          return _this2.onThumbnailsItemsClick(e);
        });
      });
    }

    /**
     * User click on a thumbnail item
     * @param {event} e
     */
  }, {
    key: "onThumbnailsItemsClick",
    value: function onThumbnailsItemsClick(e) {
      var container = e.target.closest('.m-nav-thumbnails__item');
      this.enableArrows(false);
      this.goTo(container.dataset.index || 0, 'smooth');
    }
  }, {
    key: "toggleMediasArrowButtons",
    value:
    /**
     * Display medias arrows on thumbnails if necessary
     */
    function toggleMediasArrowButtons() {
      var mediasScrollOffset = this.medias.scrollLeft;
      var mediasWidth = (this.mediasItems.length - 1) * this.medias.clientWidth;
      var _this$mediasArrows = _slicedToArray(this.mediasArrows, 2),
        arrowPrev = _this$mediasArrows[0],
        arrowNext = _this$mediasArrows[1];
      arrowPrev.classList.toggle('ka-nav-button--hidden', mediasScrollOffset <= 0);
      arrowNext.classList.toggle('ka-nav-button--hidden', mediasScrollOffset >= mediasWidth);
    }

    /**
     * When user use media arrow to scroll items
     * @param {event} event
     * @param {node} arrow
     */
  }, {
    key: "onMediasArrowsClick",
    value: function onMediasArrowsClick(event, arrow) {
      this.enableArrows(false);
      if (arrow.dataset.controls === 'prev') this.goTo(this.currentIndex - 1, "smooth");
      if (arrow.dataset.controls === 'next') this.goTo(this.currentIndex + 1, "smooth");
    }

    /**
     * Go to a specific index
     * (synchronize thumbnails and medias)
     * @param {number} index
     * @param {string} behavior
     */
  }, {
    key: "goTo",
    value: function goTo() {
      var _this3 = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      index = getMinMax(+index, 0, this.thumbnailsItems.length);
      if (index === this.currentIndex) behavior = 'instant';
      this.currentIndex = index;
      this.currentThumbnail = this.thumbnailsItems[index];
      this.currentMedia = this.mediasItems[index];
      if (this.currentThumbnail && this.currentMedia) {
        this.thumbnailsItems.forEach(function (item) {
          return item.classList.toggle('is-active', +item.dataset.index === _this3.currentIndex);
        });
        this.medias.scrollTo({
          left: this.currentMedia.offsetLeft - getComputedStyle(this.medias).borderWidth.split('px')[0] * 1,
          behavior: behavior
        });
        this.thumbnails.scrollTo({
          top: this.currentThumbnail.offsetTop,
          behavior: behavior
        });
      }

      // Reset All medias after transition
      clearTimeout(this.resetTimeout);
      this.resetTimeout = setTimeout(function () {
        _this3.pauseAllVideos();
        _this3.toggleMediasArrowButtons();
        _this3.enableArrows(true);
      }, 750);
    }

    /**
     * Enable or disable arrows buttons
     * @param {boolean} state
     */
  }, {
    key: "enableArrows",
    value: function enableArrows() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.mediasArrows.forEach(function (button) {
        return button.disabled = !state;
      });
    }

    /**
     * Rewind and pause all videos
     */
  }, {
    key: "pauseAllVideos",
    value: function pauseAllVideos() {
      this.mainCarousel.querySelectorAll('video').forEach(function (video) {
        video.pause();
        video.currentTime = 0;
      });
    }
  }]);
}();
/**
 * Return a value bettween min an max
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export { CarouselProduct as default };
function getMinMax() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var newValue = value;
  newValue = Math.max(newValue, min);
  newValue = Math.min(newValue, max);
  return newValue;
}